import { z } from 'zod';
import { CountryCode } from '../schemas/site.js';

export const CountryOverrideRow = z.object({
  wallpaper_id: z.number().int().positive(),
  country_code: CountryCode,
  status: z.enum(['draft', 'queued', 'review', 'published', 'archived']).nullable(),
});
export type CountryOverride = z.infer<typeof CountryOverrideRow>;

// Sample visibility overrides: some products hidden or shown only in specific countries.
// status=null means "inherit wallpapers.status".
export const COUNTRY_OVERRIDES: readonly CountryOverride[] = [
  { wallpaper_id: 1010, country_code: 'DE', status: 'archived'  },
  { wallpaper_id: 1020, country_code: 'DE', status: 'archived'  },
  { wallpaper_id: 1030, country_code: 'CZ', status: 'archived'  },
  { wallpaper_id: 1025, country_code: 'DE', status: 'published' },
  { wallpaper_id: 1015, country_code: 'CZ', status: 'archived'  },
] as const;

COUNTRY_OVERRIDES.forEach((o) => CountryOverrideRow.parse(o));
